import { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import Switch from "@mui/material/Switch";
import _ from "lodash";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalAgency, setSelectedAgencyId, setShowModalAccount, setSelectedAgencyName }) {
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "name",
      Header: "نام ",
      minWidth: "100px",
    },
    {
      accessor: "managerName",
      Header: "نام مدیر",
      minWidth: "100px",
    },
    {
      accessor: "salesManagerName",
      Header: "نام مدیر فروش",
      minWidth: "100px",
    },
    {
      accessor: "mobileNumber",
      Header: "شماره همراه",
      minWidth: "100px",
    },
    {
      accessor: "phoneNumber",
      Header: "شماره تلفن",
      minWidth: "100px",
    },
    {
      Header: "وضعیت",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.status ? true : false}
            //checked={state.checkedA}
            value="row.original.active"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
          // onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: "تاریخ درج",
      minWidth: "90px",
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          <Button
            title="ویرایش"
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedAgencyId(row.original.id);
              setShowModalAgency(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          {/* افزودن حساب */}
          <Button
            title="افزودن حساب"
            className="btn btn-light-warning btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedAgencyId(row.original.id);
              setSelectedAgencyName(row.original.name);
              setShowModalAccount(true);
            }}
          >
            <i className="fa fa-plus text-small ml-1"></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
